/** Resolve which conversation should receive an inbound WebSocket AG-UI frame. */
export interface WireRoutingIndex {
  sessionByConversationId: ReadonlyMap<string, unknown>
  messageIdToConversationId: ReadonlyMap<string, string>
  sessionIdToConversationId: ReadonlyMap<string, string>
}

export interface RoutableWireFields {
  conversationId?: string | null
  conversation_id?: string | null
  messageId?: string | null
  sessionId?: string | null
}

export function resolveConversationIdForWireEvent(
  event: RoutableWireFields,
  index: WireRoutingIndex,
): string | null {
  const direct = event.conversationId ?? event.conversation_id
  if (direct && index.sessionByConversationId.has(direct)) {
    return direct
  }
  const mid = event.messageId?.trim()
  if (mid) {
    const fromMessage = index.messageIdToConversationId.get(mid)
    if (fromMessage) {
      return fromMessage
    }
  }
  const sid = event.sessionId?.trim()
  if (sid) {
    const fromSession = index.sessionIdToConversationId.get(sid)
    if (fromSession) {
      return fromSession
    }
  }
  return typeof direct === 'string' && direct ? direct : null
}

export const MAX_OPEN_CONVERSATION_TABS = 5

/** Pick the oldest idle, non-running open tab to evict when at capacity. */
export function pickLruEvictionCandidate(
  openIds: readonly string[],
  activeId: string | null,
  sessions: ReadonlyMap<string, { isRunning: boolean; lastActivityAt: number }>,
): string | null {
  let candidate: { id: string; lastActivityAt: number } | null = null
  for (const id of openIds) {
    if (id === activeId) continue
    const session = sessions.get(id)
    if (!session || session.isRunning) continue
    if (!candidate || session.lastActivityAt < candidate.lastActivityAt) {
      candidate = { id, lastActivityAt: session.lastActivityAt }
    }
  }
  return candidate?.id ?? null
}
